import React from 'react';
import Orders from '../../Orders/OrdersPage';
import PageContainer from 'components/@layout/PageContainer';
import { ModuleProps } from 'types';
import HeaderBar from '../HeaderBar';
import useStore from 'store';

const AdminProductLicensesOrders: React.FC<ModuleProps> = props => {
  const [{ user }] = useStore();
  const { me } = user;

  return (
    <PageContainer {...props}>
      <HeaderBar {...props} />
      <Orders ownerEmail={me?.username} />
    </PageContainer>
  );
};

export default AdminProductLicensesOrders;
